module.exports = __webpack_public_path__ + "img/f6a4f215dc0e4949d191798ba22d2c82.cb460b1e.png";